import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/AboutPageComponents/GoverningCounsilPage/CardComponent/CardComponent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Common/FooterCard/FooterCard.tsx");
